import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import i18n from 'i18next';

import BuildingImage from './BuildingImage';

import Details from './Details';
import Spaces from './Spaces';

import {
	Container,
	Head,
	HeadWrapper,
	Name,
	City,
	BodyContainer,
	DetailsContainer
} from './styles';

const BuildingInfo = props => {
	const {
		building: {
			address,
			images,
			image,
			city,
			spaces,
			total_area,
			floors,
			mappedContacts,
		}
	} = props;
	const { language } = i18n;

	const previewImages = images.slice(0,3);
	const spaceTypes = spaces.map(space => space.type);
	let name = props.building.i18n[language].name;

	name += (name === '' ? '' : ', ') + address;

	if (previewImages.length === 0) {
		previewImages.push(image);
	}

	const contacts = mappedContacts.map(contact => contact.name);
	// typeof props.users === 'undefined' ? [] : contactEmails
	// 	.filter(contactEmail => props.users.findIndex(user => user.email === contactEmail) !== -1) // Filter out unavailable users
	// 	.map(contact => props.users.find(user => user.email === contact)) // Map to user
	// 	.map(({ firstName, lastName }) => `${firstName} ${lastName}`); // Map to user name

	return (
		<Container>
			<Head>
				<HeadWrapper>
					<Name>{name}</Name>
					<City>{city}</City>
				</HeadWrapper>
			</Head>

			<DetailsContainer>
				<BuildingImage
					viewImagesToggleHandler={props.viewImagesToggleHandler}
					images={previewImages}
				/>

				<BodyContainer>
					<Details
						floors={floors}
						totalArea={total_area}
						spaceTypes={spaceTypes}
						contacts={contacts}
					/>

					<Spaces spaces={spaces} />
				</BodyContainer>
			</DetailsContainer>
		</Container>
	);
}

BuildingInfo.defaultProps = {
	image: {},
	images: [],
}

BuildingInfo.propTypes = {
	t: PropTypes.func,
	building: PropTypes.shape({
		slug: PropTypes.text,
		name: PropTypes.string,
		contacts: PropTypes.array,
		address: PropTypes.string,
		city: PropTypes.string,
		image: PropTypes.object,
		images: PropTypes.array,
		spaces: PropTypes.array,
		fullData: PropTypes.bool,
		i18n: PropTypes.object,
	}),
	viewImagesToggleHandler: PropTypes.func,
}

export default translate('translations')(BuildingInfo);
